import { useAuthStore } from "@/features/auth/store/authStore";

export const loyaltyStore = useAuthStore;
export default loyaltyStore;